import { useState, useEffect } from 'react'
import { timeAgo } from '../lib/timeAgo'

// A self-refreshing relative-time label ("1m ago", "2h ago", ...).
// The timestamp is already on the client (chat.last_activity), so there's NO
// network here — this just re-renders ITSELF on a timer so the text keeps
// counting up without re-rendering the rest of the app. Each instance owns a
// lightweight 30s interval (cheap even for a long chat list).
export function RelativeTime({ ts, className }: { ts: number; className?: string }) {
  const [, setTick] = useState(0)
  useEffect(() => {
    if (!ts) return
    const id = setInterval(() => setTick(t => t + 1), 30_000)
    return () => clearInterval(id)
  }, [ts])
  return <span className={className}>{timeAgo(ts)}</span>
}
